import React from "react";
import ReactDOM from "react-dom";
import "./sass/index.css";
import "./sass/normalize.css";
import "./fonts/kg-no-regrets.ketch.ttf";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
